// @flow
import styled from 'styled-components';

export const SectionLabel = styled.p`
  color: var(--color-neutral-white);
  font-weight: bold;
  letter-spacing: -0.2px;
  margin-bottom: 4px;
`;

export const SectionTitle = styled.h1`
  font-size: 32px;
  font-weight: normal;
  letter-spacing: -1px;
  margin-bottom: 1rem;

  @media (min-width: 600px) {
    font-size: 48px;
  }
`;

export const SectionSubTitle = styled.h2`
  font-size: 48px;
  font-weight: normal;
  letter-spacing: -1px;
  margin-bottom: 1rem;
`;

export const SectionCopy = styled.p`
  color: var(--color-base-font);
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: ${props => (props.mb ? `${props.mb}px` : '0')};
`;

export const Message = styled.p`
  color: ${props => props.color || 'var(--color-base-font)'};
  margin-top: 16px;
`;

export const BoldText = styled.b`
  color: #4c4c4c;
`;
